<template>
  <metamap-button
    ref="button"
    :clientid="clientId"
    :flow-id="flowId"
    :metadata="`{ &quot;user_id&quot;: &quot;${userId}&quot; }`"
    color="#ffffff"
  />
</template>

<script lang="ts">
import { Vue } from 'vue-class-component'
import { State, Mutation } from 'vuex-class'
import { State as RootState } from '@/store/state'
import { KycStatus } from '@/constants'

export default class VerifyMeButton extends Vue {
  clientId: string = process.env.VUE_APP_MATI_CLIENT_ID || ''
  flowId: string = process.env.VUE_APP_MATI_FLOW_ID || ''

  $refs!: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    button: any,
  }

  @State((state: RootState) => state.user.id) userId!: number
  @Mutation setUserKycStatus!: (status: KycStatus) => void

  mounted() {
    this.$refs.button.addEventListener('metamap:userFinishedSdk', () => {
      this.setUserKycStatus(KycStatus.inProgress)
    })
  }
}
</script>

<style lang="scss">
metamap-button {
  text-transform: uppercase;
  font-weight: 600;
}
</style>
